import { useMemo } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { useSpectrum } from '@cbhq/cds-web';
import { VStack } from '@cbhq/cds-web/layout';
import { TextLegal, TextBody, Link } from '@cbhq/cds-web/typography';
import { paletteValueToCssVar } from '@cbhq/cds-web/utils/palette';
import zIndex from '../../design/themes/zIndex.js';
import '../../utils/useIsMobile/index.js';
import { useRouter } from '../RouterContext.js';
import './constants/index.js';
import { jsx } from 'react/jsx-runtime';
import useIsMobile from '../../utils/useIsMobile/useIsMobile.js';
import { MOBILE_BREAKPOINT } from './constants/constants.js';
const i18nKey = 'GlobalNav.AppWidePersistentBanner';
const messages = defineMessages({
  disclaimer: {
    id: `${i18nKey}.disclaimer`,
    defaultMessage: 'Don’t invest unless you’re prepared to lose all the money you invest. This is a high-risk investment and you should not expect to be protected if something goes wrong. <link>Take 2 mins to learn more</link>',
    description: `
    #Component: LEGACY
    #CharLimit: 305
    #Context: disclaimer text (CharLimit autocalculated to 305)`
  },
  nonRetailProductDisclaimer: {
    id: `${i18nKey}.nonRetailProductDisclaimer`,
    defaultMessage: 'In the UK, this message is for investment professionals as defined by the Financial Services and Markets Act 2000. These products are not for retail investors.',
    description: `
    #Component: LEGACY
    #CharLimit: 240
    #Context: disclaimer text (CharLimit autocalculated to 240)`
  }
});
const NON_RETAIL_PRODUCTS_PATHS = ['/derivatives', '/assethub', '/prime', '/exchange', '/international-exchange', '/commerce', '/institutional', '/private-client', '/cloud/products/staking'];
function isNonRetailProductPath(pathname) {
  return NON_RETAIL_PRODUCTS_PATHS.some(path => pathname.startsWith(path));
}
function AppWidePersistentBanner() {
  const _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  const isPhone = useIsMobile(MOBILE_BREAKPOINT);
  const TextComponent = isPhone ? TextLegal : TextBody;
  const _useRouter = useRouter(),
    pathname = _useRouter.pathname;
  const bannerMessage = useMemo(() => {
    return isNonRetailProductPath(pathname) ? messages.nonRetailProductDisclaimer : messages.disclaimer;
  }, [pathname]);
  const spectrum = useSpectrum();
  return /*#__PURE__*/jsx(VStack, {
    width: "100%",
    zIndex: zIndex.top,
    dangerouslySetBackground: paletteValueToCssVar('blue5'),
    spacing: 2,
    borderedBottom: true,
    children: /*#__PURE__*/jsx(TextComponent, {
      as: "p",
      testID: "persistent-disclaimer-text",
      dangerouslySetColor: spectrum === 'light' ? 'black' : 'white',
      align: "center",
      children: formatMessage(bannerMessage, {
        link: text => [/*#__PURE__*/jsx(Link, {
          underline: true,
          to: "https://www.coinbase.com/uk-fca-info",
          children: text || ''
        })]
      })
    })
  });
}
export { AppWidePersistentBanner };
//# sourceMappingURL=AppWidePersistentBanner.js.map
